// extracted by mini-css-extract-plugin
export default {"details":"Details_details__kpZ-x","announcement":"Details_announcement__l4n8m","date":"Details_date__YhBQY","location":"Details_location__fyNdL","hashtag":"Details_hashtag__KUuvh"};